import { render } from "./WorkspaceFederationDefinitionMetafieldsList.vue?vue&type=template&id=65e20c1a&scoped=true&ts=true"
import script from "./WorkspaceFederationDefinitionMetafieldsList.vue?vue&type=script&lang=ts"
export * from "./WorkspaceFederationDefinitionMetafieldsList.vue?vue&type=script&lang=ts"

import "./WorkspaceFederationDefinitionMetafieldsList.vue?vue&type=style&index=0&id=65e20c1a&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e20c1a"]])

export default __exports__